import type { QueryClient } from "@tanstack/react-query";
import {
  getPrivateLessonEntriesFromApi,
  type PrivateLessonsFilters,
} from "@/lib/services/privateLessonsService";
import { QueryKeys } from "@/lib/types";

export async function prefetchPrivateLessonsCalendar(
  queryClient: QueryClient,
  accessToken: string,
  filters: PrivateLessonsFilters,
  timeZone?: string | null,
) {
  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.PrivateLessonsCalendar, filters, timeZone ?? null],
    queryFn: () =>
      getPrivateLessonEntriesFromApi(accessToken, filters, timeZone),
    staleTime: 2 * 60 * 1000,
  });

  return queryClient;
}
